import { DialogHTMLAttributes, HTMLAttributes, useEffect } from 'react';
import styles from './Dialog.module.scss';
import { cn } from '../../../utils/utils';

export const Dialog: React.FC<DialogHTMLAttributes<HTMLDialogElement> & { open: boolean }> = ({
  children,
  className,
  open,
  ...props
}) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'initial';
    }

    return () => {
      document.body.style.overflow = 'initial';
    };
  }, [open]);
  return (
    <dialog data-testid="dialog" className={cn(styles['dialog'], className)} open={open} {...props}>
      {children}
    </dialog>
  );
};

export const DialogContent: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div className={cn(styles['content'], className)} data-testid="dialog-content" {...props}>
      {children}
    </div>
  );
};
